const ACCORD_SELECTOR = ".js-accord";
const ACCORD_BODY_SELECTOR = ".prefix-content-toc ul, .prefix-content-toc ol";
const ACCORD_HEADER_SELECTOR = ".js-accord__header";
const ACTIVE_CLASS = "active";

export const initAccord = () => {
    const accordList = document.querySelectorAll(ACCORD_SELECTOR);
    accordList.forEach((el) => initAccordElement(el));
};

const initAccordElement = (el) => {
    const nav = el.querySelector(ACCORD_BODY_SELECTOR);
    const header = el.querySelector(ACCORD_HEADER_SELECTOR);

    if(!nav || !header) return;

    header.addEventListener('click', () => toggleActive(el));
};

const toggleActive = (el) => {
    if(el.classList.contains(ACTIVE_CLASS)) {
        el.classList.remove(ACTIVE_CLASS);
    } else {
        el.classList.add(ACTIVE_CLASS);
    }
}

initAccord();


